import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "clearfix"
};
const _hoisted_2 = { class: "col-xs-12 col-sm-12 col-md-12" };
const _hoisted_3 = { class: "input-group top_search" };
const _hoisted_4 = { class: "col-xs-12 col-sm-12 col-md-12 border-1 bottom10" };
const _hoisted_5 = { class: "col-xs-12 col-sm-12 col-md-12 border-1 bottom10" };
const _hoisted_6 = { class: "col-xs-12 col-sm-12 col-md-12 border-1 bottom10" };
const _hoisted_7 = { class: "invalid-feedback" };
const _hoisted_8 = { class: "col-xs-12 col-sm-12 col-md-12 border-1 bottom10" };
const _hoisted_9 = { class: "col-xs-12 col-sm-12 col-md-12" };
const _hoisted_10 = { class: "float-end float-start-sm" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_multiselect = _resolveComponent("multiselect");
    const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_ContactsVue = _resolveComponent("ContactsVue");
    const _component_b_container = _resolveComponent("b-container");
    const _component_b_button = _resolveComponent("b-button");
    const _component_ReportScheduleedLogVue = _resolveComponent("ReportScheduleedLogVue");
    const _component_StatusOverlayComponent = _resolveComponent("StatusOverlayComponent");
    const _component_b_modal = _resolveComponent("b-modal");
    return (_openBlock(), _createBlock(_component_b_modal, {
        class: "modal-form-lg",
        modelValue: _ctx.showModal,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_ctx.showModal) = $event)),
        "header-bg-variant": "normal",
        size: "lg"
    }, {
        title: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                _createTextVNode("\r\n\t\t\tAutomatic Discharge Report Settings\r\n\t\t", -1 /* CACHED */)
            ]))]),
        footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_b_button, {
                    class: "me-2",
                    type: "button",
                    variant: "secondary",
                    onClick: _cache[7] || (_cache[7] = ($event) => (_ctx.showLog = true))
                }, {
                    default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                            _createElementVNode("i", {
                                class: "fa fa-list",
                                "aria-hidden": "true"
                            }, null, -1 /* CACHED */),
                            _createTextVNode(" View Log\r\n\t\t\t\t", -1 /* CACHED */)
                        ]))]),
                    _: 1 /* STABLE */
                }),
                _cache[27] || (_cache[27] = _createTextVNode()),
                _createVNode(_component_b_button, {
                    type: "button",
                    variant: "primary",
                    onClick: _ctx.save
                }, {
                    default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                            _createElementVNode("i", {
                                class: "fa fa-floppy-o",
                                "aria-hidden": "true"
                            }, null, -1 /* CACHED */),
                            _createTextVNode(" Save\r\n\t\t\t\t", -1 /* CACHED */)
                        ]))]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["onClick"]),
                _cache[28] || (_cache[28] = _createTextVNode()),
                _createVNode(_component_b_button, {
                    type: "button",
                    variant: "secondary",
                    onClick: _cache[8] || (_cache[8] = ($event) => (_ctx.showModal = false))
                }, {
                    default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                            _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* CACHED */),
                            _createTextVNode(" Cancel\r\n\t\t\t\t", -1 /* CACHED */)
                        ]))]),
                    _: 1 /* STABLE */
                })
            ])
        ]),
        default: _withCtx(() => [
            _cache[29] || (_cache[29] = _createTextVNode()),
            _createVNode(_component_b_container, { clearfix: "" }, {
                default: _withCtx(() => {
                    var _a, _b;
                    return [
                        (_ctx.model.companyId)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                _createElementVNode("div", _hoisted_2, [
                                    _createElementVNode("div", _hoisted_3, [
                                        _createVNode(_component_multiselect, {
                                            modelValue: _ctx.companyId,
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.companyId) = $event)),
                                            options: _ctx.companies,
                                            "track-by": "value",
                                            label: "text",
                                            showLabels: false,
                                            placeholder: "All company",
                                            class: "multiselect-small"
                                        }, {
                                            noResult: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                                                    _createTextVNode("\r\n\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                ]))]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["modelValue", "options"])
                                    ])
                                ]),
                                _cache[19] || (_cache[19] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_4, [
                                    _createVNode(_component_b_form_checkbox, {
                                        modelValue: _ctx.model.enabled,
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.model.enabled) = $event)),
                                        size: "lg"
                                    }, {
                                        default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                                _createTextVNode("\r\n\t\t\t\t\t\tEnabled\r\n\t\t\t\t\t", -1 /* CACHED */)
                                            ]))]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["modelValue"])
                                ]),
                                _cache[20] || (_cache[20] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_5, [
                                    _createVNode(_component_b_form_checkbox, {
                                        modelValue: _ctx.model.imperialMeasurements,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.model.imperialMeasurements) = $event)),
                                        size: "lg"
                                    }, {
                                        default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                                _createTextVNode("\r\n\t\t\t\t\t\tImperial measurements\r\n\t\t\t\t\t", -1 /* CACHED */)
                                            ]))]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["modelValue"])
                                ]),
                                _cache[21] || (_cache[21] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_6, [
                                    _cache[15] || (_cache[15] = _createElementVNode("label", null, "Minimum Discharge Duration (seconds)", -1 /* CACHED */)),
                                    _cache[16] || (_cache[16] = _createTextVNode()),
                                    _createVNode(_component_b_form_input, _mergeProps(_ctx.minDurationSecondsVal, {
                                        modelValue: _ctx.model.minDurationSeconds,
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.model.minDurationSeconds) = $event)),
                                        type: "number",
                                        step: "1",
                                        min: "0",
                                        max: "3600",
                                        class: { 'is-invalid': (_a = _ctx.errors) === null || _a === void 0 ? void 0 : _a.minDurationSeconds }
                                    }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                                    _cache[17] || (_cache[17] = _createTextVNode()),
                                    _withDirectives(_createElementVNode("div", _hoisted_7, "\r\n\t\t\t\t\t\t* Please enter a value between 0 and 3600 Seconds.\r\n\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                        [_vShow, (_b = _ctx.errors) === null || _b === void 0 ? void 0 : _b.minDurationSeconds]
                                    ])
                                ]),
                                _cache[22] || (_cache[22] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_8, [
                                    _createVNode(_component_b_form_checkbox, {
                                        modelValue: _ctx.model.automaticDuration,
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.model.automaticDuration) = $event)),
                                        size: "lg"
                                    }, {
                                        default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                                                _createTextVNode("\r\n\t\t\t\t\t\tAutomatic Duration\r\n\t\t\t\t\t", -1 /* CACHED */)
                                            ]))]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["modelValue"])
                                ]),
                                _cache[23] || (_cache[23] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_9, [
                                    _createVNode(_component_ContactsVue, {
                                        companyId: _ctx.model.companyId,
                                        filterOnlyContactsWithEmail: true,
                                        isReport: true,
                                        contactIds: _ctx.model.contactIds,
                                        "onUpdate:contactIds": _cache[5] || (_cache[5] = ($event) => ((_ctx.model.contactIds) = $event)),
                                        contactGroupIds: _ctx.model.contactGroupIds,
                                        "onUpdate:contactGroupIds": _cache[6] || (_cache[6] = ($event) => ((_ctx.model.contactGroupIds) = $event))
                                    }, null, 8 /* PROPS */, ["companyId", "contactIds", "contactGroupIds"])
                                ])
                            ]))
                            : _createCommentVNode("v-if", true)
                    ];
                }),
                _: 1 /* STABLE */
            }),
            _cache[30] || (_cache[30] = _createTextVNode()),
            _cache[31] || (_cache[31] = _createTextVNode()),
            _createVNode(_component_ReportScheduleedLogVue, {
                modelValue: _ctx.showLog,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.showLog) = $event)),
                companyId: _ctx.model.companyId
            }, null, 8 /* PROPS */, ["modelValue", "companyId"]),
            _cache[32] || (_cache[32] = _createTextVNode()),
            _createVNode(_component_StatusOverlayComponent, {
                visible: _ctx.working,
                message: "Loading..."
            }, null, 8 /* PROPS */, ["visible"])
        ]),
        _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue"]));
}
